<div class="row">
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('childUser.informationHeadline')" [innerHTML]="translationService.getTranslation('childUser.informationHeadline')"></h3>
  </div>
  <div class="col-12"
       [innerHTML]="translationService.getTranslation('childUser.informationMessage')">
  </div>
</div>
